/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CargosInputs */

const en_nav_cargos = /** @type {(inputs: Nav_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargos`)
};

const es_nav_cargos = /** @type {(inputs: Nav_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargas`)
};

/**
* | output |
* | --- |
* | "Cargos" |
*
* @param {Nav_CargosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_cargos = /** @type {((inputs?: Nav_CargosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CargosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_cargos(inputs)
	return es_nav_cargos(inputs)
});